import { render, staticRenderFns } from "./vin.vue?vue&type=template&id=a05c68f8&scoped=true"
import script from "./vin.vue?vue&type=script&lang=js"
export * from "./vin.vue?vue&type=script&lang=js"
import style0 from "./vin.vue?vue&type=style&index=0&id=a05c68f8&prod&lang=less"
import style1 from "./vin.vue?vue&type=style&index=1&id=a05c68f8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a05c68f8",
  null
  
)

export default component.exports